import React from 'react'
import QRCode from 'react-qr-code'

const QRCard = ({ value, handleRefresh, locale }) => {
  const espanol = locale === 'es';
  return (
    <>
      <div className='qr-card'>
        <div className='qr-text-container'>
          <h3 className='qr-heading'>{espanol ? 'Escanea el código QR' : 'Scan the QR Code'}</h3>
          <ul className='qr-list'>
            <li><span>{espanol ? 'Inicie cualquier entrenamiento desde la aplicación móvil.' :
                'From the mobile app start any workout'}</span></li>
            <li><span>{espanol ? 'En la pantalla de entrenamiento, toque el botón de transmisión en la parte superior y seleccione Computadora.' :
                'On the workout screen, tap the cast button on the top and select Computer.'}</span></li>
            <li><span>{espanol ? 'Apunte con su teléfono hacia esta pantalla y escanee el código QR.' :
                'Point your phone to this screen and scan the QR code'}</span></li>
            <li><span>{espanol ? 'El entrenamiento comenzará a reproducirse en el ordenador.' :
                'The workout will start playing on the desktop'}</span></li>
          </ul>
        </div>
        <div className='qr-code'>
          <QRCode value={value} size={200} />
        </div>
      </div>
      <button className='refresh-btn' onClick={handleRefresh}>{espanol ? 'Actualizar' : 'Refresh'}</button>
    </>
  )
}

export default QRCard;
